const config = {
  backendBaseUrl: process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080',
  accessTokenKey: 'batman_user_access_token',
  refreshTokenKey: 'batman_user_refresh_token',
  requiredSegment: 'BATMAN',
};

export default config;
